<div class="widget-container" #TerritoryDiv>
  <loading *ngIf="loader"></loading>
  <main>
    <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: white;">
      <div>
        <icon-chart 
          [headerConfig]="item.config['widget_header_configuration']" 
          [data]="mapData" 
          [pageKey]="pageKey"
          [heading]="item.config['report_heading']" 
          [chartName]="'TerritoryDiv'" 
          [expand]="fs"
          [fullscreen]="isFullscreen" 
          [config]="TerritoryDiv" 
          [item]="item" 
          [apiKey]="api_key" 
          [excelConfig]="excelConfig"
          [mapDesignerConfig]="savedConfigs" 
          [selectedMapConfig]="selectedMapConfig" 
          [selectedMapShowBy]="selectedShowBy" 
          (showByMapSubs)="showBySubs($event)"
          (togglePracticeType)="togglePracticeType($event)"
          (hoverValueChange)="onRangeBarHover($event)"
          >
        </icon-chart>
      </div>

      <div *ngIf="data?.length==0" style="height: 300px; width: auto;">
        <span class="bg-text">{{ error_name ? error_name : 'There is no data for this time period' }}</span>
      </div>

      <div class="territory-layout"
        [ngClass]="{ 'territory-layout--sidebyside': defaultOrder === 'sidebyside' && scorecardFlg && data?.length>0 }">
      <div class="territory-map-row" [style.display]="data?.length==0 ? 'none' : 'flex'" style="gap: 10px;" #TerritoryDiv
        [style.height.px]="isFullscreen ? window.innerHeight - 60 : (Number(this.chartHeight) || 500)">
        <div [style.width]="rightSideFlag ? (isFullscreen ? '70%' : '60%') : '100%'"
          style="height: 100%; overflow: hidden;">
          <duc-us-map *ngIf="mapConfig" [config]="mapConfig" [data]="mapData" style="display: block; width: 100%; height: 100%;">
            <duc-tooltip [config]="$any(config.components[1])">
              <ng-template #custom let-data>
                <span *ngIf="selectedMapConfig?.mode === 'default'">
                  {{ data.items[0].data.employee_first_name }} {{ data.items[0].data.employee_last_name }}
                </span>
                <span *ngIf="selectedMapConfig?.mode === 'territory-group'">
                  {{ data.items[0].data[data.items[0].key] }}
                </span>
              </ng-template>

              <ng-template #coneview let-data>
                <span *ngIf="selectedMapConfig?.mode === 'state-cone' || selectedMapConfig.mode === 'state-bubble' || selectedMapConfig.mode === 'state-icon'" style="text-align: left;">
                  <div class="du-info-card">
                    <div class="du-info-card__header">
                      {{ data.items[0].data.city }}, {{ data.items[0].data.state }}
                    </div>
                    <div class="du-info-card__body">
                      <div class="du-info-row">
                        <span class="du-info-label">{{ selectedMapConfig.mode === 'state-icon' ? 'IDN' : 'Site'}}</span>
                        <span class="du-info-value">{{ data.items[0].label }}</span>
                      </div>
                      <div class="du-info-row">
                        <span class="du-info-label"> {{ selectedMapConfig.mode === 'state-icon' ? 'Total Cancelled Patients' : 'Number of Patients'}} </span>
                        <span class="du-info-value du-info-value--bold">{{data.items[0].data.value}}</span>
                      </div>
                    </div>
                  </div>
                </span>
              </ng-template>
            </duc-tooltip>
          </duc-us-map>
        </div>

        <div *ngIf="rightSideFlag" class="scrollttm" [style.width]="isFullscreen ? '30%' : '40%'"
          style="overflow: auto; height: 100%;">
          <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel *ngFor="let userd of users"
              style="margin: 10px 3px;border-radius: 15px;border: 1px solid #E8EAEE;color:#101D42;">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span class="headertext">{{ userd.name }}</span>
                  <span class="badges">{{ userd.count }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div *ngFor="let user of userd.data">
                <hr />
                <!-- followUp template -->
                <div style="display:flex" *ngIf="userd.type == 'followUp'">
                  <div style="width:90%">
                    <div class="maindetail">{{ user.username }}</div>
                    <div class="address">
                      {{user.address.replaceAll(",,",',')}}
                      <!-- {{user.address}} -->
                      <!-- {{ user.address.street }},{{ user.address.city }},{{
                        user.address.zipcode
                      }} -->
                    </div>
                  </div>
                  <div style="width: 10%;margin: 10px auto;text-align: center;">
                    <!-- <mat-checkbox class="example-margin" matTooltip="Mark for follow up"
                            matTooltipPosition="above" [(ngModel)]="user.follow"
                            color="primary"></mat-checkbox> -->
                  </div>
                </div>
                <!-- progressBar template -->
                <div style="display:flex" *ngIf="userd.type == 'progressBar'">
                  <div style="width:90%">
                    <div class="maindetail">{{ user.username }}</div>
                    <div style="display:flex">
                      <mat-progress-bar mode="determinate" style="margin:auto" [ngClass]="'custom-progress-bar'"
                        [value]="calculatePercentage(user.volume ,userd.data)"></mat-progress-bar>
                      <!-- [value]="(userd.volume / lodash.maxBy(userd.data, 'volume')) *100"></mat-progress-bar> -->

                      <div style="width:10%;margin-left:10px">
                        <span>{{ transform(user.volume) }}</span>
                      </div>
                    </div>
                  </div>
                  <div style="width: 10%;margin: 10px auto;text-align: center;">
                    <!-- <mat-checkbox class="example-margin" matTooltip="Mark for follow up"
                            matTooltipPosition="above" [(ngModel)]="user.follow"
                            color="primary"></mat-checkbox> -->
                  </div>
                </div>
                <!-- progressBar template -->
                <div style="display:flex" *ngIf="userd.type == 'progressBarnumber'">
                  <div style="width:90%">
                    <div class="maindetail">{{ user.username }}</div>
                    <div style="display:flex">
                      <mat-progress-bar mode="determinate" style="margin:auto" color="warn"
                        [ngClass]="'warn-progress-bar'"
                        [value]="calculatePercentage(user.volume ,userd.data)"></mat-progress-bar>

                      <div style="width:10%;margin-left:10px">
                        <span>{{ user.volume }}</span>
                      </div>
                    </div>
                  </div>
                  <div style="width: 10%;margin: 10px auto;text-align: center;">
                    <!-- <mat-checkbox class="example-margin" matTooltip="Mark for follow up"
                            matTooltipPosition="above" [(ngModel)]="user.follow"
                            color="primary"></mat-checkbox> -->
                  </div>
                </div>
                <!-- progressBar template -->
                <div style="display:flex" *ngIf="userd.type == 'progressBardays'">
                  <div style="width:90%">
                    <div class="maindetail">{{ user.username }}</div>
                    <div style="display:flex">
                      <mat-progress-bar mode="determinate" [ngClass]="'custom-progress-bar'" style="margin:auto"
                        [value]="calculatePercentage(user.volume ,userd.data)"></mat-progress-bar>

                      <div style="width:20%;margin-left:10px">
                        <span>{{ user.volume + ' ' + 'days' }}</span>
                      </div>
                    </div>
                  </div>
                  <div style="width: 10%;margin: 10px auto;text-align: center;">
                    <!-- <mat-checkbox class="example-margin" matTooltip="Mark for follow up"
                            matTooltipPosition="above" [(ngModel)]="user.follow"
                            color="primary"></mat-checkbox> -->
                  </div>
                </div>
                <!-- progressBar template -->
                <div style="display:flex" *ngIf="userd.type == 'profilelist'">
                  <div>
                    <img class="imageCss" src="https://www.w3schools.com/howto/img_avatar.png" alt="Profile">
                    <!-- <mat-icon style="vertical-align: bottom;">account_circle</mat-icon> -->
                  </div>
                  <div style="width:80%; margin-left:5px">
                    <div>
                      <span class="profiletext">{{ user.name }}</span>
                    </div>
                    <div class="maindetail">{{ user.username }}</div>
                    <div class="date">{{ user.date }}</div>
                  </div>
                  <div style="width: 10%;margin: 10px auto;text-align: center;">
                    <mat-icon color="primary" style="font-size:30px">keyboard_arrow_right</mat-icon>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>

      <div id="scorecardSection" class="card mt-2" *ngIf="scorecardFlg && data?.length>0">
        <div class="widget-container" [style.display]="!mapselected ? 'none' : 'block'">
          <slope-chart
            [heading]="'IDN Breakdown'"
            [headerConfig]="this.slopeItem.config.widget_header_config"
            [config]="config"
            [data]="selectedStateData"
            [pageLevel]="true"
            [item]="slopeItem"
            [pageKey]="pageKey"
            [selectedObject]="selectedObject"
            [breakdownData]="selectedStateData"
            [error_name]="error_name"
            >
          </slope-chart>
        </div>

        <div class="idn-empty-state" [style.display]="!mapselected ? 'flex' : 'none'">
          <svg class="idn-empty-state__icon" width="29" height="35" viewBox="0 0 29 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.0834 25.75C16.5834 25.75 24.0834 19.9167 24.0834 11.8611C24.0834 5.75 19.9167 0.75 14.0834 0.75C8.25004 0.75 4.08337 5.75 4.08337 11.8611C4.08337 19.9167 11.5834 25.75 14.0834 25.75Z" stroke="#8A98AB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14.0833 11.5846C14.5436 11.5846 14.9167 11.2115 14.9167 10.7513C14.9167 10.2911 14.5436 9.91797 14.0833 9.91797C13.6231 9.91797 13.25 10.2911 13.25 10.7513C13.25 11.2115 13.6231 11.5846 14.0833 11.5846Z" fill="#8A98AB" stroke="#8A98AB" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.25 27.418C1.69089 28.1071 0.75 28.9785 0.75 29.8499C0.75 32.2496 6.75 34.0846 14.0833 34.0846C21.4167 34.0846 27.4167 32.2496 27.4167 29.8499C27.4167 28.9785 26.4758 28.1071 24.9167 27.418" stroke="#8A98AB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <div class="idn-empty-state__text">
            Select state on the map to view<br/>
            detailed IDN breakdown or
            <a class="idn-empty-state__link" (click)="showTopIdns()">show top 20 IDNs</a>
          </div>
        </div>
      </div>
      </div>

    </article>
  </main>
</div>